<div class="json-popup-container">
  <div class="popup-header">
    <h2 mat-dialog-title>{{data.title}}</h2>
  </div>

  <div class="popup-content" mat-dialog-content>
    <div class="json-viewer">
      <pre>{{formattedJson}}</pre>
    </div>
  </div>

  <div class="popup-actions" mat-dialog-actions>
    <button mat-raised-button (click)="copyToClipboard()" color="primary">
      <mat-icon>content_copy</mat-icon>
      Copy
    </button>
    <button mat-raised-button (click)="close()" color="warn">
      <mat-icon>close</mat-icon>
      Close
    </button>
  </div>
</div>